/**
 * Playground is block construct area.
 * @fileoverview This manage playground.
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _tool = require("@entrylabs/tool");
var _toast = _interopRequireDefault(require("../playground/toast"));
var _event = _interopRequireDefault(require("@entrylabs/event"));
var _Destroyer = require("../util/destroyer/Destroyer");
var _DataTable = _interopRequireDefault(require("./DataTable"));
var _sound = _interopRequireDefault(require("./sound"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Entry = require('../entry');

/**
 * Class for a playground.
 * This manage all view related with block.
 * @constructor
 */
Entry.Playground = /*#__PURE__*/function () {
  function Playground() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, Playground);
    (0, _defineProperty2["default"])(this, "getBoundingClientRectMemo", _.memoize(function (target) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rect = target.getBoundingClientRect();
      var result = {
        top: rect.top,
        bottom: rect.bottom,
        left: rect.left,
        right: rect.right
      };
      Object.keys(offset).forEach(function (key) {
        result[key] += offset[key];
      });
      return result;
    }));
    (0, _defineProperty2["default"])(this, "openDropDown", function (options, target, callback, closeCallback) {
      var containers = $('.entry-widget-dropdown');
      if (containers.length > 0) {
        closeCallback();
        return containers.remove();
      }
      var container = Entry.Dom('div', {
        "class": 'entry-widget-dropdown',
        parent: $('body')
      })[0];
      var dropdownWidget = new _tool.Dropdown({
        data: {
          items: options,
          positionDom: target,
          outsideExcludeDom: [target],
          onOutsideClick: function onOutsideClick() {
            if (dropdownWidget) {
              closeCallback();
              dropdownWidget.hide();
              dropdownWidget.remove();
            }
            if (container) {
              container.remove();
            }
          }
        },
        container: container
      }).on('select', function (item) {
        callback(item);
        closeCallback();
        dropdownWidget.hide();
      });
      return dropdownWidget;
    });
    (0, _defineProperty2["default"])(this, "openColourPicker", function (target, color, canTransparent, callback) {
      var containers = $('.entry-color-picker');
      if (containers.length > 0) {
        $(target).removeClass('on');
        return containers.remove();
      }
      var container = Entry.Dom('div', {
        "class": 'entry-color-picker',
        parent: $('body')
      })[0];
      $(target).addClass('on');
      var colorPicker = new _tool.ColorPicker({
        data: {
          color: color,
          positionDom: target,
          canTransparent: canTransparent,
          outsideExcludeDom: [target],
          onOutsideClick: function onOutsideClick(color) {
            if (colorPicker) {
              $(target).removeClass('on');
              colorPicker.hide();
              colorPicker.remove();
            }
            if (container) {
              container.remove();
            }
          }
        },
        container: container
      }).on('change', function (color) {
        if (color) {
          callback(color, true);
        }
      });
      return colorPicker;
    });
    this._destroyer = this._destroyer || new _Destroyer.Destroyer();
    this._destroyer.destroy();
    this.isTextBGMode_ = false;
    this.dataTable = _DataTable["default"];

    /**
     * playground's current view type
     * View types are 'default', 'code', 'picture', 'text', sound'
     * @type {string}
     */
    this.viewMode_ = 'default';
    Entry.addEventListener('textEdited', function () {
      _this.injectText();
    });
    Entry.addEventListener('commentVisibleChanged', this.toggleCommentButtonVisible.bind(this));
    Entry.addEventListener('workspaceChangeMode', this.updateSelectedObjectTitle.bind(this));
    Entry.windowResized.attach(this, this.clearClientRectMemo.bind(this));
  }
  return (0, _createClass2["default"])(Playground, [{
    key: "setMode",
    value: function setMode(mode) {
      this.mainWorkspace.setMode(mode);
    }

    /**
     * Control bar view generator.
     * @param {!Element} playgroundView playgroundView from Entry.
     * @param {?string} option for choose type of view.
     */
  }, {
    key: "generateView",
    value: function generateView(playgroundView) {
      var _this2 = this;
      var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'workspace';
      /** @type {!Element} */
      this.view_ = playgroundView;
      this.view_.addClass('entryPlayground');
      if (option === 'workspace' || option === 'playground') {
        this.view_.addClass('entryPlaygroundWorkspace');
        var tabView = Entry.createElement('div', 'entryCategoryTab').addClass('entryPlaygroundTabWorkspace').appendTo(this.view_);
        this.generateTabView(tabView);
        this.tabView_ = tabView;
        var tabButtonView = Entry.createElement('div', 'entryButtonTab').addClass('entryPlaygroundButtonTabWorkspace').appendTo(this.view_);
        this.tabButtonView_ = tabButtonView;
        this.createButtonTabView(tabButtonView);
        var curtainView = Entry.createElement('div', 'entryCurtain').addClass('entryPlaygroundCurtainWorkspace entryRemove').appendTo(this.view_);
        curtainView.textContent = Lang.Workspace.cannot_edit_click_to_stop;
        curtainView.addEventListener('click', function () {
          Entry.engine.toggleStop();
        });
        this.curtainView_ = curtainView;
        var pictureView = Entry.createElement('div', 'entryPicture').addClass('entryPlaygroundPictureWorkspace entryRemove').appendTo(this.view_);
        this.generatePictureView(pictureView);
        this.pictureView_ = pictureView;
        var pictureCurtainView = Entry.createElement('div', 'entryPictureCurtain').addClass('entryPlaygroundPictureCurtainWorkspace entryRemove').appendTo(pictureView);
        this.pictureCurtainView_ = pictureCurtainView;
        var pictureCurtainText = Entry.createElement('span', 'entryPictureCurtainText').addClass('entryPlaygroundPictureCurtainWorkspaceText').appendTo(pictureCurtainView);
        pictureCurtainText.textContent = Lang.Workspace.add_object_before_edit;
        var textView = Entry.createElement('div', 'entryText').addClass('entryPlaygroundTextWorkspace entryRemove').appendTo(this.view_);
        this.generateTextView(textView);
        this.textView_ = textView;
        var soundView = Entry.createElement('div', 'entrySound').addClass('entryPlaygroundSoundWorkspace entryRemove').appendTo(this.view_);
        this.generateSoundView(soundView);
        this.soundView_ = soundView;
        var defaultView = Entry.createElement('div', 'entryDefault').addClass('entryPlaygroundDefaultWorkspace').appendTo(this.view_);
        this.generateDefaultView(defaultView);
        this.defaultView_ = defaultView;

        //Code view must be append at last.
        var codeView = Entry.createElement('div', 'entryCode').addClass('entryPlaygroundCodeWorkspace entryRemove').appendTo(this.view_);
        this.generateCodeView(codeView);
        this.codeView_ = codeView;
        var backPackView = Entry.createElement('div', 'entryBackPackView').addClass('entryPlaygroundBackPackView').appendTo(this.view_);
        this.backPackView = backPackView;
        this.createBackPackView(backPackView);
        var resizeHandle = Entry.createElement('div').addClass('entryPlaygroundResizeWorkspace', 'entryRemove').bindOnClick(function () {
          _this2.mainWorkspace.blockMenu.toggleBlockMenu();
        }).appendTo(codeView);
        this.resizeHandle_ = resizeHandle;

        /** @type {!Element} */
        this.codeView_ = codeView;
        Entry.addEventListener('run', function () {
          Entry.playground.curtainView_.removeClass('entryRemove');
        });
        Entry.addEventListener('stop', function () {
          Entry.playground.curtainView_.addClass('entryRemove');
        });
        this.applyTabOption();
      }
    }

    /**
     * Generate default view.
     * default view is shown when object is not selected.
     * @param {!Element} defaultView
     * @return {Element}
     */
  }, {
    key: "generateDefaultView",
    value: function generateDefaultView(defaultView) {
      return defaultView;
    }

    /**
     * generate tab menus
     * @param {!Element} tabView
     * @return {Element}
     */
  }, {
    key: "generateTabView",
    value: function generateTabView(tabView) {
      var that = this;
      var tabList = Entry.createElement('ul').addClass('entryTabListWorkspace');
      this.tabList_ = tabList;
      tabView.appendChild(tabList);
      this.tabViewElements = {};
      var codeTab = Entry.createElement('li', 'entryCodeTab').addClass('entryTabListItemWorkspace entryTabSelected').bindOnClick(function () {
        Entry["do"]('playgroundChangeViewMode', 'code', that.selectedViewMode);
      }).appendTo(tabList);
      codeTab.textContent = Lang.Workspace.tab_code;
      this.tabViewElements.code = codeTab;
      this._codeTab = codeTab;
      var pictureTab = Entry.createElement('li', 'entryPictureTab').addClass('entryTabListItemWorkspace').bindOnClick(function () {
        Entry["do"]('playgroundChangeViewMode', 'picture', that.selectedViewMode);
      }).appendTo(tabList);
      pictureTab.textContent = Lang.Workspace.tab_picture;
      this.tabViewElements.picture = pictureTab;
      this.pictureTab = pictureTab;
      var textboxTab = Entry.createElement('li', 'entryTextboxTab').addClass('entryTabListItemWorkspace entryRemove').appendTo(tabList).bindOnClick(function () {
        Entry["do"]('playgroundChangeViewMode', 'text', that.selectedViewMode);
      });
      textboxTab.textContent = Lang.Workspace.tab_text;
      this.tabViewElements.text = textboxTab;
      this.textboxTab = textboxTab;
      var soundTab = Entry.createElement('li', 'entrySoundTab').addClass('entryTabListItemWorkspace').appendTo(tabList).bindOnClick(function () {
        Entry["do"]('playgroundChangeViewMode', 'sound', that.selectedViewMode);
      });
      soundTab.textContent = Lang.Workspace.tab_sound;
      this.tabViewElements.sound = soundTab;
      this.soundTab = soundTab;
      var variableTab = Entry.createElement('li', 'entryVariableTab').addClass('entryTabListItemWorkspace entryVariableTabWorkspace').appendTo(tabList).bindOnClick(function () {
        Entry["do"]('playgroundChangeViewMode', 'variable', that.selectedViewMode);
      });
      variableTab.textContent = Lang.Workspace.tab_attribute;
      this.tabViewElements.variable = variableTab;
      this.variableTab = variableTab;
    }
  }, {
    key: "createButtonTabView",
    value: function createButtonTabView(tabButtonView) {
      var _this3 = this;
      var _Entry$options = Entry.options,
        options = _Entry$options === void 0 ? {} : _Entry$options;
      var commentDisable = options.commentDisable,
        backpackDisable = options.backpackDisable;
      if (!commentDisable) {
        var commentToggleButton = Entry.createElement('div').addClass('entryPlaygroundCommentButtonWorkspace showComment enabled').appendTo(tabButtonView);
        commentToggleButton.setAttribute('alt', Lang.Blocks.show_all_comment);
        commentToggleButton.setAttribute('title', Lang.Blocks.show_all_comment);
        this.commentToggleButton_ = commentToggleButton;
        commentToggleButton.bindOnClick(function () {
          _this3.toggleCommentButton();
        });
        var addCommentButton = Entry.createElement('div').addClass('entryPlaygroundCommentButtonWorkspace addComment enabled').appendTo(tabButtonView);
        addCommentButton.setAttribute('alt', Lang.Blocks.add_comment);
        addCommentButton.setAttribute('title', Lang.Blocks.add_comment);
        this.addCommentButton_ = addCommentButton;
        addCommentButton.bindOnClick(function () {
          _this3.addComment();
        });
      }

      // TODO: 백팩(나의보관함) 숨김처리
      if (!backpackDisable) {
        var backPackButton = Entry.createElement('div').addClass('entryPlaygroundBackPackButtonWorkspace').appendTo(tabButtonView);
        backPackButton.setAttribute('alt', Lang.Workspace.my_storage);
        backPackButton.setAttribute('title', Lang.Workspace.my_storage);
        this.backPackButton_ = backPackButton;
        backPackButton.bindOnClick(function () {
          Entry.dispatchEvent('openBackPack');
        });
      }
    }
  }, {
    key: "createBackPackView",
    value: function createBackPackView(backPackView) {
      var _this4 = this;
      this.backPack = new _tool.Backpack({
        isShow: false,
        data: {
          items: [],
          onClose: function onClose() {
            Entry.dispatchEvent('closeBackPack');
          },
          onRemoveItem: function onRemoveItem(id) {
            Entry.dispatchEvent('removeBackPackItem', id);
          },
          onChangeTitle: function onChangeTitle(id, title) {
            Entry.dispatchEvent('changeBackPackTitle', id, title);
          },
          onCustomDragEnter: function onCustomDragEnter(_ref) {
            var type = _ref.type,
              value = _ref.value,
              onDragEnter = _ref.onDragEnter;
            if (Entry.GlobalSvg.isShow && Entry.GlobalSvg.canAddStorageBlock) {
              var _Entry$GlobalSvg$_vie = Entry.GlobalSvg._view,
                _view = _Entry$GlobalSvg$_vie === void 0 ? {} : _Entry$GlobalSvg$_vie;
              onDragEnter({
                type: 'block',
                value: _view
              });
            } else if (Entry.container.isObjectDragging) {
              onDragEnter({
                type: 'object',
                value: Entry.container.dragObjectKey
              });
            }
          },
          onDropItem: function onDropItem(_ref2) {
            var type = _ref2.type,
              value = _ref2.value;
            if (type === 'object') {
              var _object = Entry.container.getObject(value);
              _object.addStorage();
            } else if (type === 'block') {
              if (value.addStorage) {
                value.addStorage();
              }
            }
          }
        },
        container: this.backPackView
      });
      this.blockBackPackArea = Entry.Dom('div').addClass('blockBackPackDrop').appendTo(backPackView);
      this.objectBackPackArea = Entry.Dom('div').addClass('objectBackPackDrop').appendTo(backPackView);
      var icon = Entry.Dom('div', {
        "class": 'blockBackPackIcon'
      });
      var desc = Entry.Dom('div', {
        "class": 'blockBackPackDesc',
        text: Lang.Workspace.playground_block_drop
      });
      var desc2 = Entry.Dom('div', {
        "class": 'objectBackPackDesc',
        text: Lang.Workspace.container_object_drop
      });
      this.blockBackPackArea.append(icon);
      this.blockBackPackArea.append(desc);
      this.objectBackPackArea.append(icon.clone());
      this.objectBackPackArea.append(desc2);
      var _ref3 = this.board || {},
        blockView = _ref3.view;
      if (blockView) {
        var dom = blockView[0];
        var eventDom = new _event["default"](dom);
        this.blockBackPackEvent = eventDom;
        var areaDom = new _event["default"](this.blockBackPackArea[0]);
        this.blockBackPackAreaEvent = areaDom;
        areaDom.on('dropitem', function (e) {
          var data = _this4.backPack.getData('data');
          Entry.dispatchEvent('addBackPackToEntry', 'block', data);
          _this4.blockBackPackArea.css({
            display: 'none'
          });
        });
        eventDom.on('enteritem', function () {
          var isDragging = _this4.backPack.getData('isDragging');
          var type = _this4.backPack.getData('dragType');
          if (isDragging && type === 'block') {
            var _blockView$0$getBound = blockView[0].getBoundingClientRect(),
              width = _blockView$0$getBound.width,
              height = _blockView$0$getBound.height,
              top = _blockView$0$getBound.top,
              left = _blockView$0$getBound.left;
            _this4.blockBackPackArea.css({
              width: width - 134,
              height: height,
              top: top,
              left: left,
              display: 'flex'
            });
          }
        });
        areaDom.on('leaveitem', function (e) {
          _this4.blockBackPackArea.css({
            display: 'none'
          });
        });
      }
      var _ref4 = Entry.propertyPanel || {},
        _ref4$modes = _ref4.modes,
        modes = _ref4$modes === void 0 ? {} : _ref4$modes;
      var _modes$object = modes.object,
        object = _modes$object === void 0 ? {} : _modes$object;
      var objectView = object.contentDom;
      if (objectView) {
        var _dom = objectView[0];
        var _eventDom = new _event["default"](_dom);
        this.objectBackPackEvent = _eventDom;
        var _areaDom = new _event["default"](this.objectBackPackArea[0]);
        this.objectBackPackAreaEvent = _areaDom;
        _areaDom.on('dropitem', function (e) {
          var data = _this4.backPack.getData('data');
          Entry.dispatchEvent('addBackPackToEntry', 'object', data);
          _this4.objectBackPackArea.css({
            display: 'none'
          });
        });
        _eventDom.on('enteritem', function () {
          var isDragging = _this4.backPack.getData('isDragging');
          var type = _this4.backPack.getData('dragType');
          if (isDragging && type === 'object') {
            var _objectView$0$getBoun = objectView[0].getBoundingClientRect(),
              width = _objectView$0$getBoun.width,
              height = _objectView$0$getBoun.height,
              top = _objectView$0$getBoun.top,
              left = _objectView$0$getBoun.left;
            _this4.objectBackPackArea.css({
              width: width,
              height: height,
              top: top,
              left: left,
              display: 'flex'
            });
          }
        });
        _areaDom.on('leaveitem', function (e) {
          _this4.objectBackPackArea.css({
            display: 'none'
          });
        });
      }
      var globalEvent = new _event["default"](document);
      globalEvent.data = {};
      this.globalEvent = globalEvent;
      this.backPack.on('onChangeDragging', function (isDragging) {
        if (isDragging) {
          globalEvent.off().on('touchmove.itemdrag mousemove.itemdrag', function (e) {
            var isDragging = _this4.backPack.getData('isDragging');
            if (isDragging) {
              var point = Entry.Utils.getPosition(e);
              var data = globalEvent.data;
              var objectDom = _this4.objectBackPackEvent.dom;
              var blockDom = _this4.blockBackPackEvent.dom;
              var objectRect = _this4.getBoundingClientRectMemo(objectDom);
              var blockRect = _this4.getBoundingClientRectMemo(blockDom, {
                width: -134,
                right: -134
              });
              if (!data.isObjectMouseEnter && Entry.Utils.isPointInRect(point, objectRect)) {
                data.isObjectMouseEnter = true;
                _this4.objectBackPackEvent.trigger('enteritem');
              } else if (data.isObjectMouseEnter && !Entry.Utils.isPointInRect(point, objectRect)) {
                data.isObjectMouseEnter = false;
                _this4.objectBackPackAreaEvent.trigger('leaveitem');
              }
              if (Entry.getMainWS().mode === Entry.Workspace.MODE_BOARD) {
                if (!data.isBlockMouseEnter && Entry.Utils.isPointInRect(point, blockRect)) {
                  data.isBlockMouseEnter = true;
                  _this4.blockBackPackEvent.trigger('enteritem');
                } else if (data.isBlockMouseEnter && !Entry.Utils.isPointInRect(point, blockRect)) {
                  data.isBlockMouseEnter = false;
                  _this4.blockBackPackAreaEvent.trigger('leaveitem');
                }
              }
            } else {
              _this4.objectBackPackAreaEvent.trigger('leaveitem');
              _this4.blockBackPackAreaEvent.trigger('leaveitem');
            }
          }, {
            passive: false
          });
        } else {
          globalEvent.off();
        }
      });
      this.backPack.data = {
        draggableOption: {
          lockAxis: 'y',
          distance: 30,
          onDropItem: function onDropItem(e) {
            var data = globalEvent.data;
            if (data.isObjectMouseEnter) {
              data.isObjectMouseEnter = false;
              _this4.objectBackPackAreaEvent.trigger('dropitem');
            } else if (data.isBlockMouseEnter) {
              data.isBlockMouseEnter = false;
              _this4.blockBackPackAreaEvent.trigger('dropitem');
            }
          }
        }
      };
    }
  }, {
    key: "setBackpackPointEvent",
    value: function setBackpackPointEvent(canPointEvent) {
      this.backPack.data = {
        canPointEvent: canPointEvent
      };
    }
  }, {
    key: "clearClientRectMemo",
    value: function clearClientRectMemo() {
      this.getBoundingClientRectMemo.cache = new _.memoize.Cache();
    }
  }, {
    key: "showBackPack",
    value: function showBackPack(args) {
      this.backPack.setData(_objectSpread({}, args));
      this.backPack.show();
      this.backPackView.removeClass('entryRemove');
    }
  }, {
    key: "hideBackPack",
    value: function hideBackPack() {
      this.backPack.hide();
      this.backPackView.addClass('entryRemove');
    }
  }, {
    key: "toggleCommentButton",
    value: function toggleCommentButton() {
      if (this.board.isVisibleComment) {
        this.toast.show(Lang.Blocks.hide_all_comment);
        Entry["do"]('hideAllComment', this.board);
      } else {
        this.toast.show(Lang.Blocks.show_all_comment);
        Entry["do"]('showAllComment', this.board);
      }
      this.toggleCommentButtonVisible();
    }
  }, {
    key: "addComment",
    value: function addComment() {
      if (!Entry.options.commentDisable && this.board) {
        var _this$board = this.board,
          svg = _this$board.svg,
          scale = _this$board.scale;
        var boardCenterX = svg.clientWidth / 2 / scale;
        var boardCenterY = svg.clientHeight / 2 / scale;
        Entry["do"]('createComment', {
          id: Entry.Utils.generateId(),
          x: Math.max(boardCenterX - 80, 0),
          y: Math.max(boardCenterY - 80, 0)
        }, this.board);
      }
    }
  }, {
    key: "toggleCommentButtonVisible",
    value: function toggleCommentButtonVisible() {
      var button = this.commentToggleButton_;
      var addButton = this.addCommentButton_;
      if (this.board.isVisibleComment) {
        addButton.addClass('enabled');
        button.addClass('enabled');
        button.setAttribute('alt', Lang.Blocks.show_all_comment);
        button.setAttribute('title', Lang.Blocks.show_all_comment);
      } else {
        addButton.removeClass('enabled');
        button.removeClass('enabled');
        button.setAttribute('alt', Lang.Blocks.hide_all_comment);
        button.setAttribute('title', Lang.Blocks.hide_all_comment);
      }
    }

    /**
     * Inject and generate code view
     * @param {!Element} codeView
     * @return {Element}
     */
  }, {
    key: "generateCodeView",
    value: function generateCodeView(codeView) {
      var _Entry$Func, _Entry$expansion, _Entry$aiUtilize, _Entry$aiLearning;
      var variableView = this.createVariableView();
      codeView.appendChild(variableView);
      this.variableView_ = variableView;
      codeView = Entry.Dom(codeView);
      var boardView = Entry.Dom('div', {
        parent: codeView,
        id: 'entryWorkspaceBoard',
        "class": 'entryWorkspaceBoard'
      });
      this.boardView_ = boardView;
      var blockMenuView = Entry.Dom('div', {
        parent: codeView,
        id: 'entryWorkspaceBlockMenu',
        "class": 'entryWorkspaceBlockMenu'
      });
      var initOpts = {
        blockMenu: {
          dom: blockMenuView,
          align: 'LEFT',
          categoryData: EntryStatic.getAllBlocks(),
          scroll: true
        },
        board: {
          dom: boardView
        },
        readOnly: Entry.readOnly
      };
      if (Entry.textCodingEnable) {
        initOpts.vimBoard = {
          dom: boardView
        };
      }
      this.mainWorkspace = new Entry.Workspace(initOpts);
      this.blockMenu = this.mainWorkspace.blockMenu;
      this.board = this.mainWorkspace.board;
      this.toast = new _toast["default"](this.board);
      this.blockMenu.banClass('checker');
      (_Entry$Func = Entry.Func) === null || _Entry$Func === void 0 || _Entry$Func.initBlock(this.blockMenu);
      (_Entry$expansion = Entry.expansion) === null || _Entry$expansion === void 0 || _Entry$expansion.banAllExpansionBlock();
      (_Entry$aiUtilize = Entry.aiUtilize) === null || _Entry$aiUtilize === void 0 || _Entry$aiUtilize.banAllAIUtilizeBlock();
      _DataTable["default"] === null || _DataTable["default"] === void 0 || _DataTable["default"].banAllBlock();
      (_Entry$aiLearning = Entry.aiLearning) === null || _Entry$aiLearning === void 0 || _Entry$aiLearning.banBlocks();
      this.vimBoard = this.mainWorkspace.vimBoard;
      this._destroyer.add(this.mainWorkspace);
      this._destroyer.add(this.toast);
      if (Entry.hw) {
        Entry.hw.refreshHardwareBlockMenu();
      }
      if (Entry.hwLite) {
        Entry.hwLite.refreshHardwareLiteBlockMenu();
      }
      if (Entry.options.expansionDisable) {
        Entry.playground.blockMenu.banCategory('expansion');
      }
      if (Entry.options.aiUtilizeDisable) {
        Entry.playground.blockMenu.banCategory('ai_utilize');
      }
    }

    /**
     * Generate picture view.
     * @param {!Element} pictureView
     * @return {Element}
     */
  }, {
    key: "generatePictureView",
    value: function generatePictureView(PictureView) {
      var _this5 = this;
      if (Entry.type === 'workspace') {
        var pictureAdd = Entry.createElement('div', 'entryAddPicture').addClass('entryPlaygroundAddPicture').appendTo(PictureView);
        var innerPictureAdd = Entry.createElement('div', 'entryAddPictureInner').addClass('entryPlaygroundAddPictureInner').bindOnClick(function () {
          if (!Entry.container || Entry.container.isSceneObjectsExist()) {
            Entry["do"]('playgroundClickAddPicture');
          } else {
            Entry.toast.alert(Lang.Workspace.add_object_alert, Lang.Workspace.add_object_alert_msg);
          }
        }).appendTo(pictureAdd);
        innerPictureAdd.textContent = Lang.Workspace.picture_add;
        this._pictureAddButton = innerPictureAdd;
        var innerDrawNewPicture = Entry.createElement('div', 'entryNewPictureInner').addClass('entryPlaygroundNewPictureInner').bindOnClick(function () {
          _this5.painter.newPicture();
        }).appendTo(pictureAdd);
        innerDrawNewPicture.textContent = Lang.Workspace.draw_new;
        this._drawNewPictureButton = innerDrawNewPicture;
        this.pictureListView_ = Entry.createElement('ul', 'entryPictureList').addClass('entryPlaygroundPictureList').appendTo(PictureView);
        var painterDom = Entry.createElement('div', 'entryPainter').addClass('entryPlaygroundPainter').appendTo(PictureView);
        switch (Entry.paintMode) {
          case 'entry-paint':
            this.painter = new Entry.Painter(painterDom);
            break;
          case 'literallycanvas':
            this.painter = new Entry.LiterallycanvasPainter(painterDom);
            break;
        }
      }
    }
  }, {
    key: "initSortablePictureWidget",
    value: function initSortablePictureWidget() {
      if (this.pictureSortableListWidget) {
        return;
      }
      this.pictureSortableListWidget = new _tool.Sortable({
        data: {
          height: '100%',
          sortableTarget: ['entryPlaygroundPictureThumbnail'],
          lockAxis: 'y',
          items: this._getSortablePictureList()
        },
        container: this.pictureListView_
      }).on('change', function (_ref5) {
        var _ref6 = (0, _slicedToArray2["default"])(_ref5, 2),
          newIndex = _ref6[0],
          oldIndex = _ref6[1];
        Entry.playground.movePicture(newIndex, oldIndex);
      });
    }
  }, {
    key: "updatePictureView",
    value: function updatePictureView() {
      if (this.pictureSortableListWidget) {
        this.pictureSortableListWidget.setData({
          items: []
        });
        this.pictureSortableListWidget.setData({
          items: this._getSortablePictureList()
        });
      }
      this.reloadPlayground();
    }
  }, {
    key: "_getSortablePictureList",
    value: function _getSortablePictureList() {
      if (!this.object || !this.object.pictures) {
        return [];
      }
      var id = this.object.id;
      return this.object.pictures.map(function (value) {
        return {
          key: "".concat(id, "-").concat(value.id),
          item: value.view
        };
      });
    }

    /**
     * Generate text view.
     * @param {!Element} textView
     * @return {Element}
     */
  }, {
    key: "generateTextView",
    value: function generateTextView(textView) {
      var _this6 = this;
      var that = this;
      var wrap = Entry.createElement('div').addClass('write_box').appendTo(textView);
      var writeSet = Entry.createElement('div').addClass('write_set');
      var inputArea = Entry.createElement('div').addClass('input_box');
      wrap.appendChild(writeSet);
      wrap.appendChild(inputArea);

      //write set 글 속성 탭
      var fontSelect = Entry.createElement('div').addClass('pop_selectbox');
      var fontLink = Entry.createElement('a', 'entryTextBoxAttrFontName').addClass('select_link imico_pop_select_arr_down');
      fontLink.bindOnClick(function () {
        var options = EntryStatic.fonts.filter(function (font) {
          return font.visible;
        }).map(function (font) {
          return [font.name, font, font.style];
        });
        fontLink.addClass('imico_pop_select_arr_up');
        fontLink.removeClass('imico_pop_select_arr_down');
        _this6.openDropDown(options, fontLink, function (value) {
          var font = value[1];
          var textValue = textEditInput.value;
          if (that.object.entity.getLineBreak()) {
            textValue = textEditArea.value;
          }
          var _Entry$options2 = Entry.options,
            options = _Entry$options2 === void 0 ? {} : _Entry$options2;
          var _options$textOptions = options.textOptions,
            textOptions = _options$textOptions === void 0 ? {} : _options$textOptions;
          var hanjaEnable = textOptions.hanjaEnable;
          if (!hanjaEnable) {
            if (/[\u4E00-\u9FFF]/.exec(textValue) != null) {
              font = options[0][1];
              Entry.modal.alert(Lang.Menus.not_supported_text);
            }
          }
          fontLink.innerText = font.name;
          _this6.textEditArea.style.fontFamily = font.family;
          _this6.textEditInput.style.fontFamily = font.family;
          $('#entryTextBoxAttrFontName').data('font', font);
          _this6.object.entity.setFontType(font.family);
        }, function () {
          fontLink.removeClass('imico_pop_select_arr_up');
          fontLink.addClass('imico_pop_select_arr_down');
        });
      });
      fontSelect.appendChild(fontLink);
      writeSet.appendChild(fontSelect);

      //스타일 박스
      var alignBox = Entry.createElement('div').addClass('font_style_box');
      writeSet.appendChild(alignBox);
      var alignLeft = Entry.createElement('a').addClass('style_link imbtn_pop_font_align_left').bindOnClick(function () {
        Entry.playground.setFontAlign(Entry.TEXT_ALIGN_LEFT);
      });
      alignLeft.setAttribute('title', Lang.Workspace.align_left);
      alignBox.appendChild(alignLeft);
      this.alignLeftBtn = alignLeft;
      var alignMiddle = Entry.createElement('a').addClass('style_link imbtn_pop_font_align_middle').bindOnClick(function () {
        Entry.playground.setFontAlign(Entry.TEXT_ALIGN_CENTER);
      });
      alignMiddle.setAttribute('title', Lang.Workspace.align_center);
      alignBox.appendChild(alignMiddle);
      this.alignCenterBtn = alignMiddle;
      var alignRight = Entry.createElement('a').addClass('style_link imbtn_pop_font_align_right').bindOnClick(function () {
        Entry.playground.setFontAlign(Entry.TEXT_ALIGN_RIGHT);
      });
      alignRight.setAttribute('title', Lang.Workspace.align_right);
      alignBox.appendChild(alignRight);
      this.alignRightBtn = alignRight;
      var styleBox = Entry.createElement('div').addClass('font_style_box');
      writeSet.appendChild(styleBox);
      var bold = Entry.createElement('a').addClass('style_link imbtn_pop_font_bold').bindOnClick(function (e) {
        $(e.currentTarget).toggleClass('on');
        Entry.playground.object.entity.toggleFontBold();
        $(_this6.textEditArea).toggleClass('bold');
        $(_this6.textEditInput).toggleClass('bold');
      });
      bold.setAttribute('title', Lang.Workspace.bold);
      styleBox.appendChild(bold);
      var underLine = Entry.createElement('a').addClass('style_link imbtn_pop_font_underline').bindOnClick(function (e) {
        var underLineState = !Entry.playground.object.entity.getUnderLine() || false;
        $(e.currentTarget).toggleClass('on');
        Entry.playground.object.entity.setUnderLine(underLineState);
        var effect = "".concat(underLineState ? 'underline' : '', " ").concat(Entry.playground.object.entity.getStrike() ? 'line-through' : '').trim();
        _this6.textEditArea.style.textDecoration = effect;
        _this6.textEditInput.style.textDecoration = effect;
      });
      underLine.setAttribute('title', Lang.Workspace.font_underline);
      styleBox.appendChild(underLine);
      var italic = Entry.createElement('a').addClass('style_link imbtn_pop_font_italic').bindOnClick(function (e) {
        $(e.currentTarget).toggleClass('on');
        Entry.playground.object.entity.toggleFontItalic();
        $(_this6.textEditArea).toggleClass('italic');
        $(_this6.textEditInput).toggleClass('italic');
      });
      italic.setAttribute('title', Lang.Workspace.font_tilt);
      styleBox.appendChild(italic);
      var through = Entry.createElement('a').addClass('style_link imbtn_pop_font_through').bindOnClick(function (e) {
        $(e.currentTarget).toggleClass('on');
        var strikeState = !Entry.playground.object.entity.getStrike() || false;
        Entry.playground.object.entity.setStrike(strikeState);
        var effect = "".concat(strikeState ? 'line-through' : '', " ").concat(Entry.playground.object.entity.getUnderLine() ? 'underline' : '').trim();
        _this6.textEditArea.style.textDecoration = effect;
        _this6.textEditInput.style.textDecoration = effect;
      });
      through.setAttribute('title', Lang.Workspace.font_cancel);
      styleBox.appendChild(through);
      var color = Entry.createElement('a').addClass('imbtn_pop_font_color');
      color.appendChild(Entry.createElement('em'));
      color.bindOnClick(function () {
        return _this6.openColourPicker(color, _this6.object.entity.getColour(), false, _this6.setTextColour.bind(_this6));
      });
      color.setAttribute('title', Lang.Workspace.font_color);
      styleBox.appendChild(color);
      var backgroundColor = Entry.createElement('a').addClass('imbtn_pop_font_backgroundcolor');
      backgroundColor.setAttribute('title', Lang.Workspace.font_fill);
      backgroundColor.appendChild(Entry.createElement('em'));
      backgroundColor.bindOnClick(function () {
        return _this6.openColourPicker(backgroundColor, _this6.object.entity.getBGColour(), true, _this6.setBackgroundColour.bind(_this6));
      });
      styleBox.appendChild(backgroundColor);
      var writeTypeBox = Entry.createElement('div').addClass('write_type_box');
      var singleLine = Entry.createElement('a');
      singleLine.innerText = Lang.Buttons.single_line;
      singleLine.bindOnClick(function () {
        return Entry.playground.toggleLineBreak(false);
      });
      var multiLine = Entry.createElement('a');
      multiLine.innerText = Lang.Buttons.multi_line;
      multiLine.bindOnClick(function () {
        return Entry.playground.toggleLineBreak(true);
      });
      writeTypeBox.appendChild(singleLine);
      writeTypeBox.appendChild(multiLine);
      inputArea.appendChild(writeTypeBox);

      //글자 크기 조절 슬라이드.
      var fontSizeWrapper = Entry.createElement('div').addClass('entryPlaygroundFontSizeWrapper multi');
      inputArea.appendChild(fontSizeWrapper);
      this.fontSizeWrapper = fontSizeWrapper;
      var fontSizeLabel = Entry.createElement('div').addClass('entryPlaygroundFontSizeLabel');
      fontSizeLabel.textContent = Lang.General.font_size;
      fontSizeWrapper.appendChild(fontSizeLabel);
      var fontSizeSlider = Entry.createElement('div').addClass('entryPlaygroundFontSizeSlider');
      fontSizeWrapper.appendChild(fontSizeSlider);
      var fontSizeIndiciator = Entry.createElement('div').addClass('entryPlaygroundFontSizeIndicator');
      fontSizeSlider.appendChild(fontSizeIndiciator);
      this.fontSizeIndiciator = fontSizeIndiciator;
      var fontSizeKnob = Entry.createElement('div').addClass('entryPlaygroundFontSizeKnob');
      fontSizeSlider.appendChild(fontSizeKnob);
      this.fontSizeKnob = fontSizeKnob;
      $(fontSizeKnob).bind('mousedown.fontKnob touchstart.fontKnob', function () {
        var resizeOffset = $(fontSizeSlider).offset().left;
        var doc = $(document);
        doc.bind('mousemove.fontKnob touchmove.fontKnob', onMouseMove);
        doc.bind('mouseup.fontKnob touchend.fontKnob', onMouseUp);
        function onMouseMove(e) {
          var x = e.pageX;
          if (!x) {
            x = e.originalEvent.touches[0].pageX;
          }
          var left = x - resizeOffset;
          left = Math.max(left, 5);
          left = Math.min(left, 136);
          fontSizeKnob.style.left = "".concat(left, "px");
          left /= 1.36;
          fontSizeIndiciator.style.width = "".concat(left, "%");
          Entry.playground.object.entity.setFontSize(left);
        }
        function onMouseUp() {
          $(document).unbind('.fontKnob');
        }
      });
      var inputInner = Entry.createElement('div').addClass('input_inner');
      inputArea.appendChild(inputInner);
      var textEditInput = Entry.createElement('input').addClass('entryPlayground_textBox single');
      textEditInput.type = 'text';
      textEditInput.placeholder = Lang.Workspace.textbox_input;
      var textChangeApply = function textChangeApply() {
        var object = Entry.playground.object;
        var entity = object.entity;
        var selected = $('#entryTextBoxAttrFontName').data('font');
        var defaultFont = EntryStatic.fonts[0];
        var _Entry$options3 = Entry.options,
          options = _Entry$options3 === void 0 ? {} : _Entry$options3;
        var _options$textOptions2 = options.textOptions,
          textOptions = _options$textOptions2 === void 0 ? {} : _options$textOptions2;
        var hanjaEnable = textOptions.hanjaEnable;
        if (!hanjaEnable && (selected.family === 'Nanum Pen Script' || selected.family === 'Jeju Hallasan')) {
          if (/[\u4E00-\u9FFF]/.exec(this.value) != null) {
            $('#entryTextBoxAttrFontName').text(defaultFont.name);
            entity.setFontType(defaultFont.family);
            Entry.modal.alert(Lang.Menus.not_supported_text);
          }
        }
        object.setText(this.value);
        entity.setText(this.value);
      };
      textEditInput.onkeyup = textChangeApply;
      textEditInput.onchange = textChangeApply;
      textEditInput.addEventListener('focusin', function () {
        textEditInput.prevText = textEditInput.value;
      });
      textEditInput.onblur = function () {
        if (textEditInput.value !== textEditInput.prevText) {
          Entry["do"]('editText', textEditInput.value, textEditInput.prevText);
        }
        // Entry.dispatchEvent('textEdited');
      };
      this.textEditInput = textEditInput;
      inputInner.appendChild(textEditInput);
      var textEditArea = Entry.createElement('textarea');
      textEditArea.placeholder = Lang.Workspace.textbox_input;
      textEditArea.addClass('entryPlayground_textArea multi');
      textEditArea.style.display = 'none';
      textEditArea.onkeyup = textChangeApply;
      textEditArea.onchange = textChangeApply;
      textEditArea.addEventListener('focusin', function () {
        textEditArea.prevText = textEditArea.value;
      });
      textEditArea.onblur = function () {
        if (textEditArea.value !== textEditArea.prevText) {
          Entry["do"]('editText', textEditArea.value, textEditArea.prevText);
        }
      };
      this.textEditArea = textEditArea;
      inputInner.appendChild(textEditArea);
      var singleDesc = Entry.createElement('ul').addClass('list single');
      singleDesc.appendChild(Entry.createElement('li').text(Lang.Menus.linebreak_off_desc_1));
      singleDesc.appendChild(Entry.createElement('li').text(Lang.Menus.linebreak_off_desc_2));
      singleDesc.appendChild(Entry.createElement('li').text(Lang.Menus.linebreak_off_desc_3));
      var multiDesc = Entry.createElement('ul').addClass('list multi');
      multiDesc.appendChild(Entry.createElement('li').text(Lang.Menus.linebreak_on_desc_1));
      multiDesc.appendChild(Entry.createElement('li').text(Lang.Menus.linebreak_on_desc_2));
      multiDesc.appendChild(Entry.createElement('li').text(Lang.Menus.linebreak_on_desc_3));
      inputArea.appendChild(singleDesc);
      inputArea.appendChild(multiDesc);
    }

    /**
     * 소리 편집 기능 신규 개발시 해당 로직 삭제
     * @private
     */
  }, {
    key: "_createSoundEditView",
    value: function _createSoundEditView() {
      var soundEditView = Entry.createElement('div', 'entrySoundEdit').addClass('entryPlaygroundSoundEdit');
      return soundEditView;
    }

    /**
     * Generate sound view.
     * default view is shown when object is not selected.
     * @return {Element}
     * @param soundView
     */
  }, {
    key: "generateSoundView",
    value: function generateSoundView(soundView) {
      if (Entry.type === 'workspace') {
        var soundAdd = Entry.createElement('div', 'entryAddSound');
        soundAdd.addClass('entryPlaygroundAddSound');
        var innerSoundAdd = Entry.createElement('div', 'entryAddSoundInner').addClass('entryPlaygroundAddSoundInner');
        innerSoundAdd.bindOnClick(function () {
          if (!Entry.container || Entry.container.isSceneObjectsExist()) {
            Entry["do"]('playgroundClickAddSound');
          } else {
            Entry.toast.alert(Lang.Workspace.add_object_alert, Lang.Workspace.add_object_alert_msg);
          }
        });
        innerSoundAdd.textContent = Lang.Workspace.sound_add;
        soundAdd.appendChild(innerSoundAdd);
        soundView.appendChild(soundAdd);
        var soundList = Entry.createElement('ul', 'entrySoundList').addClass('entryPlaygroundSoundList');
        soundView.appendChild(soundList);
        this.soundListView_ = soundList;
        this._soundAddButton = innerSoundAdd;
        var soundEditView = this._createSoundEditView();
        soundView.appendChild(soundEditView);
        this.soundEditor = new _sound["default"](soundEditView);
      }
    }
  }, {
    key: "initSortableSoundWidget",
    value: function initSortableSoundWidget() {
      if (this.soundSortableListWidget) {
        return;
      }
      this.soundSortableListWidget = new _tool.Sortable({
        data: {
          height: '100%',
          sortableTarget: ['entryPlaygroundSoundThumbnail'],
          lockAxis: 'y',
          items: this._getSortableSoundList()
        },
        container: this.soundListView_
      }).on('change', function (_ref7) {
        var _ref8 = (0, _slicedToArray2["default"])(_ref7, 2),
          newIndex = _ref8[0],
          oldIndex = _ref8[1];
        Entry.playground.moveSound(newIndex, oldIndex);
      });
    }
  }, {
    key: "updateSoundsView",
    value: function updateSoundsView() {
      if (this.soundSortableListWidget) {
        this.soundSortableListWidget.setData({
          items: this._getSortableSoundList()
        });
      }
      this.reloadPlayground();
    }
  }, {
    key: "_getSortableSoundList",
    value: function _getSortableSoundList() {
      if (!this.object || !this.object.sounds) {
        return [];
      }
      var id = this.object.id;
      return this.object.sounds.map(function (value) {
        return {
          key: "".concat(id, "-").concat(value.id),
          item: value.view
        };
      });
    }

    /**
     * Inject object
     * @param {?Entry.EntryObject} object
     */
  }, {
    key: "injectObject",
    value: function injectObject(object) {
      /** @type {Entry.Entryobject} */
      if (!object) {
        this.object = null; //[박봉배-2018.11.12] - 아래 위치에 있으면 죽은 object의 메서드를 호출함. 그래서 위로 올림.
        this.changeViewMode('code');
        return;
      }
      if (object === this.object) {
        return;
      }
      this.object = object;
      var objectType = object.objectType;
      this.setMenu(objectType);
      this.injectCode();
      var _this$tabViewElements = this.tabViewElements,
        textTab = _this$tabViewElements.text,
        pictureTab = _this$tabViewElements.picture;
      if (objectType === 'sprite' && Entry.pictureEditable) {
        if (textTab) {
          textTab.addClass('entryRemove');
        }
        if (pictureTab) {
          pictureTab.removeClass('entryRemove');
        }
      } else if (objectType === 'textBox') {
        if (pictureTab) {
          pictureTab.addClass('entryRemove');
        }
        if (textTab) {
          textTab.removeClass('entryRemove');
        }
      }
      this.updateObjectTitle(object);
      var viewMode = this.viewMode_;
      if (viewMode === 'default') {
        this.changeViewMode('code');
      } else if (viewMode === 'variable') {
        this.changeViewMode('variable');
      } else if ((viewMode === 'picture' || viewMode === 'text') && objectType === 'textBox') {
        this.changeViewMode('text');
      } else if ((viewMode === 'text' || viewMode === 'picture') && objectType === 'sprite') {
        this.changeViewMode('picture');
      } else if (viewMode === 'sound') {
        this.changeViewMode('sound');
      }
      _.result(this.blockMenu, 'clearRendered');
      this.reloadPlayground();
    }

    /**
     * Inject object
     * @param {?Entry.EntryObject} object
     */
  }, {
    key: "injectEmptyObject",
    value: function injectEmptyObject() {
      this.object = null;
    }

    /**
     * Inject code
     */
  }, {
    key: "injectCode",
    value: function injectCode() {
      var workspace = Entry.getMainWS();
      if (!workspace) {
        return;
      }
      var object = this.object;
      var vimBoard = workspace.vimBoard;
      if (vimBoard && Entry.textCodingEnable && !vimBoard._parser._onError) {
        vimBoard._changedObject = object;
        vimBoard._currentScene = object.scene;
      }
      var board = workspace.getBoard();
      var engine = Entry.engine;
      workspace.changeBoardCode(object.script, engine && engine.isState('run') ? undefined : board.adjustThreadsPosition.bind(board));
    }

    /**
     * Inject picture
     */
  }, {
    key: "injectPicture",
    value: function injectPicture() {
      var isSelect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var view = this.pictureListView_;
      if (!view) {
        return;
      }
      if (!this.object) {
        this.painter.lc && this.painter.lc.pointerDown();
        delete Entry.stage.selectedObject;
        Entry.dispatchEvent('pictureSelected');
      } else {
        (this.object.pictures || []).forEach(function (picture, i) {
          !picture.view && Entry.playground.generatePictureElement(picture);
          var element = picture.view;
          element.orderHolder.textContent = i + 1;
        });
        isSelect && this.selectPicture(this.object.selectedPicture);
      }
      this.updatePictureView();
    }

    /**
     * Add picture
     * @param {picture model} picture
     */
  }, {
    key: "addPicture",
    value: function addPicture(picture, isNew) {
      var isSelect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var tempPicture = _.clone(picture);
      if (isNew === true) {
        delete tempPicture.id;
      }
      delete tempPicture.view;
      picture = Entry.Utils.copy(tempPicture);
      if (!picture.id) {
        picture.id = Entry.generateHash();
      }
      picture.name = Entry.getOrderedName(picture.name, this.object.pictures);
      this.generatePictureElement(picture);
      Entry["do"]('objectAddPicture', picture.objectId || this.object.id, picture, isSelect);
    }

    /**
     * set picture
     * @param {picture}
     */
  }, {
    key: "setPicture",
    value: function setPicture(picture) {
      var element = Entry.container.getPictureElement(picture.id, picture.objectId);
      var $element = $(element);
      if (element) {
        picture.view = element;
        element.picture = picture;
        var thumbnailView = $element.find("#t_".concat(picture.id))[0];
        if (picture.thumbUrl || picture.fileurl) {
          thumbnailView.style.backgroundImage = "url(\"".concat(picture.thumbUrl || picture.fileurl, "\")");
        } else {
          // deprecated
          var fileName = picture.filename;
          thumbnailView.style.backgroundImage = "url(\"".concat(Entry.defaultPath, "/uploads/").concat(fileName.substring(0, 2), "/").concat(fileName.substring(2, 4), "/thumb/").concat(fileName, ".png\")");
        }
        var sizeView = $element.find("#s_".concat(picture.id))[0];
        sizeView.textContent = "".concat(picture.dimension.width, " X ").concat(picture.dimension.height);
      }
      Entry.container.setPicture(picture);
      // Entry.playground.object.setPicture(picture);
    }

    /**
     * Download a picture
     * @param {!String} pictureId
     */
  }, {
    key: "downloadPicture",
    value: function downloadPicture(pictureId) {
      var picture = Entry.playground.object.getPicture(pictureId);
      var _picture$imageType = picture.imageType,
        imageType = _picture$imageType === void 0 ? 'png' : _picture$imageType;
      Entry.dispatchEvent('downloadPicture', picture);
    }

    /**
     * Clone picture
     * @param {!String} pictureId
     */
  }, {
    key: "clonePicture",
    value: function clonePicture(pictureId) {
      var sourcePicture = Entry.playground.object.getPicture(pictureId);
      this.addPicture(sourcePicture, true);
    }

    /**
     * Select picture
     * @param {picture}
     */
  }, {
    key: "selectPicture",
    value: function selectPicture(picture, removed) {
      var pictures = this.object.pictures;
      for (var i = 0, len = pictures.length; i < len; i++) {
        var target = pictures[i];
        var view = target.view;
        if (target.id === picture.id) {
          view.addClass('entryPictureSelected');
        } else {
          view.removeClass('entryPictureSelected');
        }
      }
      var objectId_;
      if (picture && picture.id) {
        objectId_ = Entry.container.selectPicture(picture.id, picture.objectId);
      }
      if (this.object.id === objectId_) {
        if (!picture.objectId) {
          picture.objectId = this.object.id;
        }
        Entry.dispatchEvent('pictureSelected', picture, removed);
      }
      this.updateObjectTitle(this.object);
    }

    /**
     * Move picture in this.object.pictures
     * this method is for sortable
     * @param {!number} start
     * @param {!number} end
     */
  }, {
    key: "movePicture",
    value: function movePicture(start, end) {
      this.object.pictures.splice(end, 0, this.object.pictures.splice(start, 1)[0]);
      this.injectPicture();
    }

    /**
     * Inject text
     */
  }, {
    key: "injectText",
    value: function injectText() {
      var object = this.object;
      if (!object) {
        return;
      }
      var entity = object.entity;
      var text = entity.getText();
      this.textEditInput.value = text;
      this.textEditArea.value = text;
      var font = EntryStatic.fonts.filter(function (font) {
        return font.visible;
      }).find(function (font) {
        return font.family === entity.getFontName();
      });
      if (font) {
        $('#entryText #entryTextBoxAttrFontName').text(font.name);
        $('#entryText #entryTextBoxAttrFontName').data('font', font);
        this.textEditInput.style.fontFamily = font.family;
        this.textEditArea.style.fontFamily = font.family;
      } else {
        $('#entryText #entryTextBoxAttrFontName').text('');
        $('#entryText #entryTextBoxAttrFontName').data('font', EntryStatic.fonts[0]);
      }
      if (entity.colour) {
        this.setTextColour(entity.colour, true);
      }
      if (entity.bgColor) {
        this.setBackgroundColour(entity.bgColor, true);
      }
      this.setTextBold(entity.fontBold);
      this.setTextItalic(entity.fontItalic);
      this.setTextDecoration(entity);
      this.toggleLineBreak(entity.getLineBreak());
      if (entity.getLineBreak()) {
        var LANG = Lang.Menus;
        $('.entryPlaygroundLinebreakDescription > p').html(LANG.linebreak_on_desc_1);
        var pDoms = $('.entryPlaygroundLinebreakDescription > ul > li');
        pDoms.eq(0).text(LANG.linebreak_on_desc_2);
        pDoms.eq(1).text(LANG.linebreak_on_desc_3);
        this._setFontFontUI();
      }
      this.setFontAlign(entity.getTextAlign());
      Entry.stage.updateForce();
    }
  }, {
    key: "_setFontFontUI",
    value: function _setFontFontUI() {
      var fontSize = this.object.entity.getFontSize();
      this.fontSizeIndiciator.style.width = "".concat(fontSize, "%");
      this.fontSizeKnob.style.left = "".concat(fontSize * 1.36, "px");
    }

    /**
     * Inject sound
     */
  }, {
    key: "injectSound",
    value: function injectSound() {
      var isSelect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var view = this.soundListView_;
      if (!view) {
        return;
      }
      if (!this.object) {
        delete Entry.stage.selectedObject;
      } else {
        (this.object.sounds || []).forEach(function (sound, i) {
          var soundLengthView = (0, _get2["default"])(sound, 'view.soundLengthView');
          if (soundLengthView) {
            soundLengthView.textContent = "".concat(sound.duration, " ").concat(Lang.General.second);
          } else {
            Entry.playground.generateSoundElement(sound);
          }
          var element = sound.view;
          element.orderHolder.textContent = i + 1;
        });
        if (isSelect) {
          if (this.object.selectedSound) {
            this.selectSound(this.object.selectedSound);
          } else {
            this.unselectSound();
          }
        }
      }
      this.updateSoundsView();
    }

    /**
     * Move sound in this.object.sounds
     * this method is for sortable
     * @param {!number} start
     * @param {!number} end
     */
  }, {
    key: "moveSound",
    value: function moveSound(start, end) {
      if (this.object.sounds) {
        this.object.sounds.splice(end, 0, this.object.sounds.splice(start, 1)[0]);
        this.injectSound();
      }
    }
  }, {
    key: "addHardwareLiteModule",
    value: function addHardwareLiteModule(module) {
      Entry.hwLite.addHardwareLiteModule(module);
    }
  }, {
    key: "removeHardwareLiteModule",
    value: function removeHardwareLiteModule() {
      Entry.hwLite.removeHardwareLiteModule();
    }
  }, {
    key: "addExpansionBlocks",
    value: function addExpansionBlocks(items) {
      Entry.expansion.addExpansionBlocks(items.map(function (_ref9) {
        var name = _ref9.name;
        return name;
      }));
    }
  }, {
    key: "removeExpansionBlocks",
    value: function removeExpansionBlocks(items) {
      Entry.expansion.banExpansionBlocks(items.map(function (_ref0) {
        var name = _ref0.name;
        return name;
      }));
    }
  }, {
    key: "addAIUtilizeBlocks",
    value: function addAIUtilizeBlocks(items) {
      Entry.aiUtilize.addAIUtilizeBlocks(items.map(function (_ref1) {
        var name = _ref1.name;
        return name;
      }));
    }
  }, {
    key: "removeAIUtilizeBlocks",
    value: function removeAIUtilizeBlocks(items) {
      Entry.aiUtilize.banAIUtilizeBlocks(items.map(function (_ref10) {
        var name = _ref10.name;
        return name;
      }));
    }
  }, {
    key: "setAiLearningBlock",
    value: function setAiLearningBlock(data) {
      Entry.aiLearning.removeLearningBlocks();
      Entry.aiLearning.load(_objectSpread({}, data));
    }

    /**
     * Add sound
     * @param {sound model} sound
     * @param {boolean} NotForView if this is true, add element into object also.
     */
  }, {
    key: "addSound",
    value: function addSound(sound, NotForView, isNew) {
      var isSelect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var tempSound = _.clone(sound);
      delete tempSound.view;
      if (isNew === true) {
        delete tempSound.id;
      }
      sound = Entry.Utils.copy(tempSound);
      if (!sound.id) {
        sound.id = Entry.generateHash();
      }
      sound.name = Entry.getOrderedName(sound.name, this.object.sounds);
      this.generateSoundElement(sound);
      Entry["do"]('objectAddSound', sound.objectId || this.object.id, sound, isSelect);
    }
  }, {
    key: "downloadSound",
    value: function downloadSound(soundId) {
      var sound = Entry.playground.object.getSound(soundId);
      Entry.dispatchEvent('downloadSound', sound);
    }

    /**
     * select view mode
     * @param {string} viewType
     */
  }, {
    key: "changeViewMode",
    value: function changeViewMode(viewType) {
      if (!this.tabViewElements) {
        return;
      }
      for (var i in this.tabViewElements) {
        this.tabViewElements[i].removeClass('entryTabSelected');
      }
      if (viewType !== 'default') {
        this.tabViewElements[viewType].addClass('entryTabSelected');
      }
      if (viewType === 'variable') {
        Entry.playground.toggleOnVariableView();
        this.tabViewElements.code.removeClass('entryTabSelected');
        this.tabViewElements[viewType].addClass('entryTabSelected');
        this.resizeHandle_.removeClass('unfolding');
        this.resizeHandle_.addClass('entryRemove');
        this.boardView_.addClass('wideView');
        Entry.windowResized.notify();
        return;
      } else {
        this.resizeHandle_.removeClass('entryRemove');
        this.boardView_.removeClass('wideView');
        Entry.windowResized.notify();
      }
      var views = this.view_.children;
      for (var _i = 0; _i < views.length; _i++) {
        var view = views[_i];
        if (view.id.toUpperCase().indexOf(viewType.toUpperCase()) > -1) {
          view.removeClass('entryRemove');
        } else {
          view.addClass('entryRemove');
        }
      }
      if (Entry.pictureEditable) {
        if (viewType === 'picture') {
          this.painter.show();
          this.initSortablePictureWidget();
          if (!this.pictureView_.object || this.pictureView_.object != this.object) {
            this.pictureView_.object = this.object;
            this.injectPicture();
          } else if (this.object && this.pictureListView_ && !this.pictureListView_.hasChildNodes()) {
            var pictures = this.object.pictures;
            if (pictures && pictures.length) {
              this.injectPicture();
            }
          }
        } else {
          this.painter.hide();
        }
      }
      if (Entry.soundEditable) {
        if (viewType === 'sound') {
          this.initSortableSoundWidget();
          if (!this.soundView_.object || this.soundView_.object != this.object) {
            this.soundView_.object = this.object;
            this.injectSound();
          } else if (this.object && this.soundListView_ && !this.soundListView_.hasChildNodes()) {
            var sounds = this.object.sounds;
            if (sounds && sounds.length) {
              this.injectSound();
            }
          }
        } else {
          this.soundEditor.hide();
        }
      }
      if (viewType === 'text' && this.object.objectType === 'textBox' || this.textView_.object != this.object) {
        this.textView_.object = this.object;
        this.injectText();
      }
      if (viewType === 'code') {
        this.resizeHandle_ && this.resizeHandle_.removeClass('entryRemove');
        this.tabButtonView_ && this.tabButtonView_.addClass('entryCode');
        this.blockMenu.reDraw();
      } else {
        this.tabButtonView_ && this.tabButtonView_.removeClass('entryCode');
      }
      if (Entry.engine.isState('run')) {
        this.curtainView_.removeClass('entryRemove');
      }
      this.viewMode_ = viewType;
      this.selectedViewMode = viewType;
      this.toggleOffVariableView();
    }

    /**
     * render variable view
     * @return {!Element}
     */
  }, {
    key: "createVariableView",
    value: function createVariableView() {
      var view = Entry.createElement('div');
      if (!Entry.type || Entry.type === 'workspace') {
        view.addClass('entryVariablePanelWorkspace');
      } else if (Entry.type === 'phone') {
        view.addClass('entryVariablePanelPhone');
      }
      this.variableViewWrapper_ = view;
      Entry.variableContainer.createDom(view);
      return view;
    }

    /**
     * toggle on variable view
     */
  }, {
    key: "toggleOnVariableView",
    value: function toggleOnVariableView() {
      Entry.playground.changeViewMode('code');
      this.hideBlockMenu();
      this.variableView_.removeClass('entryRemove');
      this.resizeHandle_.removeClass('entryRemove');
      this.viewMode_ = 'variable';
      this.selectedViewMode = 'variable';
    }
  }, {
    key: "toggleOffVariableView",
    value: function toggleOffVariableView() {
      this.showBlockMenu();
      this.variableView_.addClass('entryRemove');
    }

    /**
     * Generate category menu with object type.
     * @param {!string} objectType
     */
  }, {
    key: "setMenu",
    value: function setMenu(objectType) {
      if (this.currentObjectType == objectType) {
        return;
      }
      var blockMenu = this.blockMenu;
      blockMenu.unbanClass(this.currentObjectType, true);
      blockMenu.banClass(objectType, true);
      blockMenu.setMenu(true);
      this.currentObjectType = objectType;
    }
  }, {
    key: "hideTabs",
    value: function hideTabs() {
      ['picture', 'text', 'sound', 'variable'].forEach(this.hideTab.bind(this));
    }
  }, {
    key: "hideTab",
    value: function hideTab(item) {
      if (this.tabViewElements[item]) {
        this.tabViewElements[item].addClass('hideTab');
        this.tabViewElements[item].removeClass('showTab');
      }
    }
  }, {
    key: "showTabs",
    value: function showTabs() {
      ['picture', 'text', 'sound', 'variable'].forEach(this.showTab.bind(this));
    }
  }, {
    key: "showTab",
    value: function showTab(item) {
      if (this.tabViewElements[item]) {
        this.tabViewElements[item].addClass('showTab');
        this.tabViewElements[item].removeClass('hideTab');
      }
    }

    /**
     * Reload playground
     */
  }, {
    key: "reloadPlayground",
    value: function reloadPlayground() {
      var engine = Entry.engine;
      if (engine && engine.isState('run')) {
        return;
      }
      _.result(this.mainWorkspace, 'dReDraw');
    }

    /**
     * flush playground when object is not exist
     */
  }, {
    key: "flushPlayground",
    value: function flushPlayground() {
      this.object = null;
      if (Entry.playground && Entry.playground.view_) {
        this.injectPicture();
        this.injectSound();
        var mainWS = Entry.getMainWS();
        if (mainWS) {
          var board = mainWS.getBoard();
          board.clear();
          board.changeCode(null);
        }
      }
    }
  }, {
    key: "refreshPlayground",
    value: function refreshPlayground() {
      if (Entry.playground && Entry.playground.view_) {
        if (this.getViewMode() === 'picture') {
          this.injectPicture();
        }
        if (this.getViewMode() === 'sound') {
          this.injectSound();
        }
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.flushPlayground();
      if (this.painter) {
        this.painter.clear();
      }
    }
  }, {
    key: "nameViewBlur",
    value: function nameViewBlur() {
      var _this7 = this;
      if (!Entry.playground.nameViewFocus) {
        return;
      }
      if (this.nameView.value.trim() === '') {
        Entry.modal.alert(Lang.Workspace.enter_the_name).then(function () {
          _this7.nameView.focus();
        });
        return true;
      }
      var nameViewArray = $('.entryPlaygroundPictureName');
      if (nameViewArray.length !== Entry.playground.object.pictures.length) {
        nameViewArray = nameViewArray.slice(0, -1); // pop last element (드래그 시 발생하는 임시 엘리먼트임)
      }
      for (var i = 0; i < nameViewArray.length; i++) {
        if (nameViewArray.eq(i).val() == this.nameView.value && nameViewArray[i] != this.nameView) {
          Entry.modal.alert(Lang.Workspace.name_already_exists).then(function () {
            _this7.nameView.focus();
          });
          return true;
        }
      }
      var newValue = this.nameView.value;
      this.nameView.picture.name = newValue;
      var playground = Entry.playground;
      if (playground) {
        if (playground.object) {
          var pic = playground.object.getPicture(this.nameView.picture.id);
          if (pic) {
            pic.name = newValue;
          }
        }
        var painter = playground.painter;
        if (painter && painter.file) {
          painter.file.name = newValue;
        }
        playground.reloadPlayground();
      }
      Entry.dispatchEvent('pictureNameChanged', this.nameView.picture);
      Entry.playground.nameViewFocus = false;
    }
  }, {
    key: "isDuplicatedTableName",
    value: function isDuplicatedTableName(name) {
      var selectedIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      var nameViewArray = $('.entryPlaygroundTableName');
      if (nameViewArray.length !== Entry.playground.dataTable.tables.length) {
        nameViewArray = nameViewArray.slice(0, -1);
      }
      for (var i = 0; i < nameViewArray.length; i++) {
        if (nameViewArray.eq(i).val() == name && i != selectedIndex) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "generatePictureElement",
    value: function generatePictureElement(picture) {
      var _this8 = this;
      var element = Entry.createElement('li', picture.id).addClass('entryPlaygroundPictureElement').bindOnClick(function () {
        Entry.playground.selectPicture(this.picture);
      });
      picture.view = element;
      element.picture = picture;
      Entry.Utils.disableContextmenu(picture.view);
      Entry.ContextMenu.onContextmenu(picture.view, function (coordinate) {
        var options = [{
          text: Lang.Workspace.context_rename,
          callback: function callback() {
            nameView.focus();
          }
        }, {
          text: Lang.Workspace.context_duplicate,
          callback: function callback() {
            Entry.playground.clonePicture(picture.id);
          }
        }, {
          text: Lang.Workspace.context_remove,
          callback: function callback() {
            Entry.playground._removePicture(picture, element);
          }
        }, {
          text: Lang.Workspace.context_download_image,
          callback: function callback() {
            Entry.playground.downloadPicture(picture.id);
          }
        }];
        Entry.ContextMenu.show(options, 'workspace-contextmenu', coordinate);
      });
      element.orderHolder = Entry.createElement('div').addClass('entryPlaygroundPictureOrder').appendTo(element);
      var thumbnailView = Entry.createElement('div', "t_".concat(picture.id)).addClass('entryPlaygroundPictureThumbnail');
      var mouseDownCoordinate;
      var moveThreshold = 5;
      thumbnailView.addEventListener('touchstart', function (e) {
        var event = Entry.Utils.convertMouseEvent(e);
        mouseDownCoordinate = {
          y: event.clientY
        };
      });
      thumbnailView.addEventListener('touchmove', function (e) {
        e.preventDefault();
        var event = Entry.Utils.convertMouseEvent(e);
        if (Math.abs(event.clientY - mouseDownCoordinate.y) > moveThreshold) {
          Entry.ContextMenu.hide();
        }
      });
      if (picture.thumbUrl || picture.fileurl) {
        thumbnailView.style.backgroundImage = "url(\"".concat(picture.thumbUrl || picture.fileurl, "\")");
      } else {
        // deptecated
        var fileName = picture.filename;
        thumbnailView.style.backgroundImage = "url(\"".concat(Entry.defaultPath, "/uploads/").concat(fileName.substring(0, 2), "/").concat(fileName.substring(2, 4), "/thumb/").concat(fileName, ".png\")");
      }
      element.appendChild(thumbnailView);
      var nameView = Entry.createElement('input').addClass('entryPlaygroundPictureName').addClass('entryEllipsis');
      nameView.picture = picture;
      nameView.value = picture.name;
      Entry.attachEventListener(nameView, 'blur', this.nameViewBlur.bind(this));
      Entry.attachEventListener(nameView, 'focus', function (e) {
        _this8.nameView = e.target;
        _this8.nameViewFocus = true;
      });
      nameView.onkeypress = Entry.Utils.blurWhenEnter;
      element.appendChild(nameView);
      Entry.createElement('div', "s_".concat(picture.id)).addClass('entryPlaygroundPictureSize').appendTo(element).textContent = "".concat(picture.dimension.width, " X ").concat(picture.dimension.height);
      var removeButton = Entry.createElement('div').addClass('entryPlayground_del');
      var _ref11 = Lang || {},
        _ref11$Buttons = _ref11.Buttons,
        Buttons = _ref11$Buttons === void 0 ? {} : _ref11$Buttons;
      var _Buttons$delete = Buttons["delete"],
        delText = _Buttons$delete === void 0 ? '삭제' : _Buttons$delete;
      removeButton.appendTo(element).innerText = delText;
      removeButton.bindOnClick(function (e) {
        try {
          e.stopPropagation();
          _this8._removePicture(picture, element);
        } catch (e) {
          Entry.toast.alert(Lang.Workspace.shape_remove_fail, Lang.Workspace.shape_remove_fail_msg);
        }
      });
    }
  }, {
    key: "_removePicture",
    value: function _removePicture(picture, element) {
      if (Entry.playground.object.pictures.length > 1) {
        Entry["do"]('objectRemovePicture', picture.objectId, picture);
        Entry.removeElement(element);
        Entry.toast.success(Lang.Workspace.shape_remove_ok, "".concat(picture.name, " ").concat(Lang.Workspace.shape_remove_ok_msg));
      } else {
        Entry.toast.alert(Lang.Workspace.shape_remove_fail, Lang.Workspace.shape_remove_fail_msg);
      }
    }
  }, {
    key: "generateSoundElement",
    value: function generateSoundElement(sound) {
      var _this9 = this;
      var element = Entry.createElement('sound', sound.id).addClass('entryPlaygroundSoundElement');
      sound.view = element;
      element.sound = sound;
      Entry.Utils.disableContextmenu(sound.view);
      Entry.ContextMenu.onContextmenu(sound.view, function (coordinate) {
        var options = [{
          text: Lang.Workspace.context_rename,
          callback: function callback() {
            nameView.focus();
          }
        }, {
          text: Lang.Workspace.context_duplicate,
          callback: function callback() {
            var newSound = Entry.playground.object.getSound(sound.id);
            Entry.playground.addSound(newSound, true, true);
          }
        }, {
          text: Lang.Workspace.context_remove,
          callback: function callback() {
            var result = Entry["do"]('objectRemoveSound', Entry.playground.object.id, sound);
            if (result) {
              Entry.removeElement(element);
              Entry.dispatchEvent('removeSound', sound);
              Entry.toast.success(Lang.Workspace.sound_remove_ok, "".concat(sound.name, " ").concat(Lang.Workspace.sound_remove_ok_msg));
            } else {
              Entry.toast.alert(Lang.Workspace.sound_remove_fail, '');
            }
            Entry.removeElement(element);
          }
        }, {
          text: Lang.Workspace.context_download_sound,
          callback: function callback() {
            Entry.playground.downloadSound(sound.id);
          }
        }];
        Entry.ContextMenu.show(options, 'workspace-contextmenu', coordinate);
      });
      element.orderHolder = Entry.createElement('div').addClass('entryPlaygroundSoundOrder').appendTo(element);
      var thumbnailView = Entry.createElement('div').addClass('entryPlaygroundSoundThumbnail entryPlaygroundSoundPlay').appendTo(element);
      var isPlaying = false;
      var soundInstance;
      element.bindOnClick(function () {
        if (!_this9.object.sounds || !_this9.object.sounds.length) {
          return;
        }
        var isExist = _this9.object.sounds.some(function (os) {
          return os.id === sound.id;
        });
        if (isExist) {
          _this9.selectSound(sound);
        }
      });
      var mouseDownCoordinate;
      var moveThreshold = 5;
      thumbnailView.addEventListener('touchstart', function (e) {
        var event = Entry.Utils.convertMouseEvent(e);
        mouseDownCoordinate = {
          y: event.clientY
        };
      });
      thumbnailView.addEventListener('touchmove', function (e) {
        e.preventDefault();
        var event = Entry.Utils.convertMouseEvent(e);
        if (Math.abs(event.clientY - mouseDownCoordinate.y) > moveThreshold) {
          Entry.ContextMenu.hide();
        }
      });
      thumbnailView.bindOnClick(function () {
        _this9.selectSound(sound);
        if (isPlaying) {
          isPlaying = false;
          thumbnailView.removeClass('entryPlaygroundSoundStop');
          thumbnailView.addClass('entryPlaygroundSoundPlay');
          soundInstance.dispatchEvent('complete');
          soundInstance.stop();
          return;
        } else {
          isPlaying = true;
          thumbnailView.removeClass('entryPlaygroundSoundPlay');
          thumbnailView.addClass('entryPlaygroundSoundStop');
          soundInstance = Entry.Utils.playSound(sound.id);
          Entry.Utils.addSoundInstances(soundInstance);
        }
        soundInstance.addEventListener('complete', function () {
          thumbnailView.removeClass('entryPlaygroundSoundStop');
          thumbnailView.addClass('entryPlaygroundSoundPlay');
          isPlaying = false;
        });
      });
      var nameView = Entry.createElement('input').addClass('entryPlaygroundSoundName').appendTo(element);
      nameView.sound = sound;
      nameView.value = sound.name;
      Entry.attachEventListener(nameView, 'blur', nameViewBlur);
      function nameViewBlur() {
        if (this.value.trim() === '') {
          return Entry.modal.alert(Lang.Workspace.enter_the_name).then(function () {
            nameView.focus();
          });
        }
        var nameViewArray = $('.entryPlaygroundSoundName');
        if (nameViewArray.length !== Entry.playground.object.sounds.length) {
          nameViewArray = nameViewArray.slice(0, -1); // pop last element (드래그 시 발생하는 임시 엘리먼트임)
        }
        for (var i = 0; i < nameViewArray.length; i++) {
          if (nameViewArray.eq(i).val() == nameView.value && nameViewArray[i] != this) {
            return Entry.modal.alert(Lang.Workspace.name_already_exists).then(function () {
              nameView.focus();
            });
          }
        }
        var newValue = this.value;
        this.sound.name = newValue;
        Entry.playground.reloadPlayground();
      }
      nameView.onkeypress = Entry.Utils.blurWhenEnter;
      var soundLengthView = Entry.createElement('div').addClass('entryPlaygroundSoundLength').appendTo(element);
      soundLengthView.textContent = "".concat(sound.duration, " ").concat(Lang.General.second);
      element.soundLengthView = soundLengthView;
      var removeButton = Entry.createElement('div').addClass('entryPlayground_del');
      var _ref12 = Lang || {},
        _ref12$Buttons = _ref12.Buttons,
        Buttons = _ref12$Buttons === void 0 ? {} : _ref12$Buttons;
      var _Buttons$delete2 = Buttons["delete"],
        delText = _Buttons$delete2 === void 0 ? '삭제' : _Buttons$delete2;
      removeButton.appendTo(element).innerText = delText;
      removeButton.bindOnClick(function () {
        try {
          Entry.Utils.forceStopSounds();
          var result = Entry["do"]('objectRemoveSound', Entry.playground.object.id, sound);
          if (result) {
            Entry.dispatchEvent('removeSound', sound);
            Entry.toast.success(Lang.Workspace.sound_remove_ok, "".concat(sound.name, " ").concat(Lang.Workspace.sound_remove_ok_msg));
          } else {
            Entry.toast.alert(Lang.Workspace.sound_remove_fail, '');
          }
          Entry.removeElement(element);
        } catch (e) {
          Entry.toast.alert(Lang.Workspace.sound_remove_fail, '');
        }
      });
    }
  }, {
    key: "selectSound",
    value: function selectSound(sound) {
      this.object.sounds.forEach(function (item) {
        if (item.id !== sound.id) {
          item.view.removeClass('entrySoundSelected');
        } else {
          item.view.addClass('entrySoundSelected');
        }
      });
      var objectId_;
      if (sound && sound.id) {
        objectId_ = Entry.container.selectSound(sound.id, sound.objectId);
      }
      if (this.object.id === objectId_) {
        if (!sound.objectId) {
          sound.objectId = this.object.id;
        }
        Entry.dispatchEvent('soundSelected', sound, this.object);
      }
    }
  }, {
    key: "unselectSound",
    value: function unselectSound() {
      Entry.dispatchEvent('soundUnselected');
    }
  }, {
    key: "setTextColour",
    value: function setTextColour(colour) {
      $('.imbtn_pop_font_color em').css('background-color', colour);
      this.object.entity.setColour(colour);
      this.textEditArea.style.color = colour;
      this.textEditInput.style.color = colour;
    }
  }, {
    key: "setTextBold",
    value: function setTextBold(bold) {
      $('.style_link.imbtn_pop_font_bold').toggleClass('on', bold);
      $(this.textEditInput).removeClass('bold');
      $(this.textEditArea).removeClass('bold');
      if (bold) {
        $(this.textEditInput).addClass('bold');
        $(this.textEditArea).addClass('bold');
      }
    }
  }, {
    key: "setTextItalic",
    value: function setTextItalic(fontItalic) {
      $('.style_link.imbtn_pop_font_italic').toggleClass('on', fontItalic);
      $(this.textEditInput).removeClass('italic');
      $(this.textEditArea).removeClass('italic');
      if (fontItalic) {
        $(this.textEditInput).addClass('italic');
        $(this.textEditArea).addClass('italic');
      }
    }
  }, {
    key: "setTextDecoration",
    value: function setTextDecoration(entity) {
      $('.style_link.imbtn_pop_font_underline').toggleClass('on', entity.getUnderLine());
      $('.style_link.imbtn_pop_font_through').toggleClass('on', entity.getStrike());
      var effect = "".concat(entity.getStrike() ? 'line-through' : '', " ").concat(entity.getUnderLine() ? 'underline' : '').trim();
      this.textEditArea.style.textDecoration = effect;
      this.textEditInput.style.textDecoration = effect;
    }
  }, {
    key: "setBackgroundColour",
    value: function setBackgroundColour(colour) {
      $('.imbtn_pop_font_backgroundcolor em').css('background-color', colour);
      $('.imbtn_pop_font_backgroundcolor').toggleClass('clear', colour === 'transparent' || colour === '#ffffff');
      this.object.entity.setBGColour(colour);
      this.textEditArea.style.backgroundColor = colour;
      this.textEditInput.style.backgroundColor = colour;
    }
  }, {
    key: "isTextBGMode",
    value: function isTextBGMode() {
      return this.isTextBGMode_;
    }
  }, {
    key: "checkVariables",
    value: function checkVariables() {
      if (Entry.forEBS) {
        return;
      }
      var blockMenu = this.blockMenu;
      var _Entry$variableContai = Entry.variableContainer,
        lists_ = _Entry$variableContai.lists_,
        variables_ = _Entry$variableContai.variables_;
      if (lists_.length) {
        blockMenu.unbanClass('listNotExist');
      } else {
        blockMenu.banClass('listNotExist');
      }
      if (variables_.length) {
        blockMenu.unbanClass('variableNotExist');
      } else {
        blockMenu.banClass('variableNotExist');
      }
    }
  }, {
    key: "getViewMode",
    value: function getViewMode() {
      return this.viewMode_;
    }
  }, {
    key: "banExpansionBlock",
    value: function banExpansionBlock() {
      var blockMenu = _.result(this.mainWorkspace, 'blockMenu');
      if (!blockMenu) {
        return;
      }
      Object.values(Entry.EXPANSION_BLOCK_LIST).forEach(function (block) {
        blockMenu.banClass(block.name, true);
        blockMenu.banClass("".concat(block.name, "_legacy"), true);
      });
    }
  }, {
    key: "banAIUtilizeBlock",
    value: function banAIUtilizeBlock() {
      var blockMenu = _.result(this.mainWorkspace, 'blockMenu');
      if (!blockMenu) {
        return;
      }
      Object.values(Entry.ALL_AI_UTILIZE_BLOCK_LIST).forEach(function (block) {
        blockMenu.banClass(block.name, true);
        blockMenu.banClass("".concat(block.name, "_legacy"), true);
      });
    }
  }, {
    key: "banHardwareLiteBlock",
    value: function banHardwareLiteBlock() {
      var blockMenu = _.result(this.mainWorkspace, 'blockMenu');
      if (!blockMenu) {
        return;
      }
      Object.values(Entry.HARDWARE_LITE_LIST).forEach(function (block) {
        blockMenu.banClass(block.name, true);
        blockMenu.banClass("".concat(block.name, "_legacy"), true);
        blockMenu.banClass("".concat(block.name.toLowerCase()), true);
      });
    }
  }, {
    key: "toggleLineBreak",
    value: function toggleLineBreak(isLineBreak) {
      var _ref13 = this.object || {},
        objectType = _ref13.objectType,
        entity = _ref13.entity;
      if (objectType !== 'textBox') {
        return;
      }
      $('.write_type_box a').removeClass('on');
      if (isLineBreak) {
        entity.setLineBreak(true);
        $('.input_inner').height('228px');
        $('.write_type_box a').eq(1).addClass('on');
        $('.input_box .single').hide();
        $('.input_box .multi').show();
        this._setFontFontUI();
      } else {
        entity.setLineBreak(false);
        $('.input_inner').height('40px');
        $('.write_type_box a').eq(0).addClass('on');
        $('.input_box .multi').hide();
        $('.input_box .single').show();
      }
    }
  }, {
    key: "setFontAlign",
    value: function setFontAlign(fontAlign) {
      if (this.object.objectType !== 'textBox') {
        return;
      }
      this.alignLeftBtn.removeClass('on');
      this.alignCenterBtn.removeClass('on');
      this.alignRightBtn.removeClass('on');
      switch (fontAlign) {
        case Entry.TEXT_ALIGN_LEFT:
          this.alignLeftBtn.addClass('on');
          break;
        case Entry.TEXT_ALIGN_CENTER:
          this.alignCenterBtn.addClass('on');
          break;
        case Entry.TEXT_ALIGN_RIGHT:
          this.alignRightBtn.addClass('on');
          break;
      }
      this.object.entity.setTextAlign(fontAlign);
    }
  }, {
    key: "showPictureCurtain",
    value: function showPictureCurtain() {
      this.pictureCurtainView_ && this.pictureCurtainView_.removeClass('entryRemove');
    }
  }, {
    key: "hidePictureCurtain",
    value: function hidePictureCurtain() {
      this.pictureCurtainView_ && this.pictureCurtainView_.addClass('entryRemove');
    }
  }, {
    key: "hideBlockMenu",
    value: function hideBlockMenu() {
      this.mainWorkspace.getBlockMenu().hide();
    }
  }, {
    key: "showBlockMenu",
    value: function showBlockMenu() {
      this.mainWorkspace.getBlockMenu().show();
    }
  }, {
    key: "getDom",
    value: function getDom(query) {
      if (query.length) {
        switch (query.shift()) {
          case 'tabViewElements':
            return this.tabViewElements[query.shift()];
          case 'blockMenu':
            return this.blockMenu.getDom(query);
          case 'board':
          case 'overlayBoard':
            return this.mainWorkspace.getCurrentBoard().getDom(query);
          case 'pictureAddButton':
            return this._pictureAddButton;
          case 'soundAddButton':
            return this._soundAddButton;
        }
      } else {}
    }
  }, {
    key: "applyTabOption",
    value: function applyTabOption() {
      this.textboxTab.addClass('entryRemove');
      this.pictureTab.addClass('entryRemove');
      this.soundTab.addClass('entryRemove');
      this.variableTab.addClass('entryRemove');
      if (Entry.pictureEditable) {
        this.pictureTab.removeClass('entryRemove');
        this.textboxTab.removeClass('entryRemove');
      }
      if (Entry.soundEditable) {
        this.soundTab.removeClass('entryRemove');
      }
      if (Entry.hasVariableManager) {
        this.variableTab.removeClass('entryRemove');
      }
    }
  }, {
    key: "updateObjectTitle",
    value: function updateObjectTitle(object) {
      if (this.board) {
        this.board.updateObjectTitle(object);
      }
    }
  }, {
    key: "updateSelectedObjectTitle",
    value: function updateSelectedObjectTitle() {
      if (this.board && Entry.container.selectedObject && this.board.workspace.getMode() === Entry.Workspace.MODE_BOARD) {
        this.board.updateObjectTitle(Entry.container.selectedObject);
        Entry.Utils.doCodeChange();
      }
    }
  }, {
    key: "setSound",
    value: function setSound(sound) {
      var objectSound = Entry.container.setSound(sound);
      if (objectSound !== null && objectSound !== void 0 && objectSound.view) {
        objectSound.view.sound = objectSound;
      }
      var soundLengthView = (0, _get2["default"])(objectSound, 'view.soundLengthView');
      if (soundLengthView) {
        soundLengthView.textContent = "".concat(objectSound.duration, " ").concat(Lang.General.second);
      }
      return objectSound;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.commentToggleButton_ && this.commentToggleButton_.unBindOnClick();
      this.addCommentButton_ && this.addCommentButton_.unBindOnClick();
      this.backPackButton_ && this.backPackButton_.unBindOnClick();
      this.blockBackPackEvent && this.blockBackPackEvent.off();
      this.blockBackPackAreaEvent && this.blockBackPackAreaEvent.off();
      this.objectBackPackEvent && this.objectBackPackEvent.off();
      this.objectBackPackAreaEvent && this.objectBackPackAreaEvent.off();
      this.globalEvent && this.globalEvent.destroy();
      this.soundEditor && this.soundEditor.destory();
      this._destroyer.destroy();
    }
  }]);
}();